export function toArray<T>(value: T | T[]): T[] {
  let ret: T[];
  if (value == null) {
    ret = [];
  } else if (!Array.isArray(value)) {
    ret = [value];
  } else {
    ret = value;
  }
  return ret;
}

export function arraysEqual<T>(array1: T[], array2: T[]): boolean {
  if (!array1 || !array2 || array1.length !== array2.length) {
    return false;
  }

  const len = array1.length;
  for (let i = 0; i < len; i++) {
    if (array1[i] !== array2[i]) {
      return false;
    }
  }
  return true;
}

export function shallowCopyArray<T>(source: T[]): T[] {
  return source.slice();
}

export function compare(key: any, isDesc: boolean) {
  // tslint:disable-next-line:only-arrow-functions
  return (x: any, y: any) => {
    if (!x.hasOwnProperty(key) ||
      !y.hasOwnProperty(key)) {
      return 0;
    }

    const key1 = (typeof x[key] === 'string') ?
      x[key].toUpperCase() : x[key];
    const key2 = (typeof y[key] === 'string') ?
      y[key].toUpperCase() : y[key];

    let comparison = 0;
    if (key1 > key2) {
      comparison = 1;
    } else if (key1 < key2) {
      comparison = -1;
    }
    return (
      isDesc ? (comparison * -1) : comparison
    );
  };
}

export function sortArray(objectArray: Array<any>, key: string, isDesc?: boolean) {
  return objectArray.sort(compare(key, isDesc));
}
